// MONASTERY (chapel restoration) screen markup. The chapel header + item grid
// are rendered by the controller (monastery.ts) into #monBody.
//
// db/047 adds two economy sinks below the gallery grid (PLAN-gameplay-v2 §1):
//   #monWings   — the expansion ladder, rendered by monasteryWings.ts
//   #monAlmsBtn — the door to the Poor Box overlay (almsgiving.ts)
// Both are user-initiated surfaces, not interstitials: nothing here goes
// through the Moment Director.
import { icon } from '../ui/icons';

export const monasteryHTML = /* html */ `
<div id="screenMonastery" class="monastery-screen hidden">
  <button class="btn secondary back" id="monBackBtn" type="button" style="width:auto;padding:10px 16px;">← Home</button>
  <div class="content-head">
    <div class="content-title">${icon('church')} The Monastery</div>
    <div class="content-sub" id="monSub">Restore the chapel, piece by piece</div>
  </div>
  <div id="monChapel" class="mon-chapel"></div>
  <div id="monNote" class="collections-note hidden"></div>
  <div id="monBody" class="mon-body"></div>
  <div id="monWings" class="wing-section"></div>
  <div class="alms-door">
    <button class="btn secondary alms-door-btn" id="monAlmsBtn" type="button">
      <span class="alms-door-ic" aria-hidden="true">${icon('coin', 22)}</span>
      <span class="alms-door-main">
        <span class="alms-door-title">The Poor Box</span>
        <span class="alms-door-sub" id="monAlmsSub">Give to the monastery's works of mercy</span>
      </span>
    </button>
  </div>
  <div id="monToast" class="acct-toast hidden" role="status" aria-live="polite"></div>
</div>`;
